<template>
    <div class="rechercheRevue">
        <div class="container container-revue">
            <div class="rechercheRevue-header" v-if="!isMobile">
                <div class="back btn" @click="back"><span class="back-label">Retour</span></div>
                <div class="title">{{ currentAbonnement.label }}</div>
                <div class="filters">
                    <select @change="onChange($event)" v-model="selectedDate" class="btn btn-select" v-if="selectedDate">
                        <option :value="date" v-for="date in dates" :key="date">{{ date }}</option>
                    </select>
                </div>
            </div>
            <div class="rechercheRevue-header" v-else>
                <div class="rechercheRevue-header--wrapper">
                    <div class="back btn" @click="back"><span class="back-label">Retour</span></div>
                    <div class="title">{{ currentAbonnement.label }}</div>
                </div>
                <div class="filters">
                    <select @change="onChange($event)" v-model="selectedDate" class="btn btn-select" v-if="selectedDate">
                        <option :value="date" v-for="date in dates" :key="date">{{ date }}</option>
                    </select>
                </div>
            </div>
            <div class="rechercheRevue-descriptions">
                <p v-html="description"></p>
            </div>
            <div class="rechercheRevue-liste" v-if="!emptyNum">
                <div class="numero-item" :data-num-revue="num.numero" v-for="num in listeNum" :key="num" @click="OnSearchNumRevue($event)">
                    <div class="numero-img">
                        <img :src="num.cover" :alt="num.numero" v-if="num.cover">
                        <img src="@/assets/images/livres.jpg" alt="" v-else>
                    </div>
                    <div class="numero-text">Numéro {{ num.numero }}</div>
                </div>
            </div>
            <div class="rechercheRevue-liste" v-else>Aucun numéro de revue disponible</div>
        </div>
    </div>
</template>

<script>
import { toRaw } from 'vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import { DESCRIPTIONREVUE_CONSTANTS } from '@/constants/descriptionRevueConstants';

export default {
    name: "RevueRecherche",
    props: ['currentAbonnement'],
    data() {
        return {
            dates: [],
            selectedDate: null,
            listeNum: [],
            emptyNum: false,
            filters: {
                query: null,
                documentId: 1,
                nomrevue: [],
                motcle: [],
                rubrique: [],
                specialite: [],
                annee_debut: null,
                annee_fin: null,
                annee_parution: null,
                num_revue: null,
                page_debut: null
            },
            description: ""
        }
    },
    watch: {
        currentAbonnement: {
            handler() {
                this.setOnLoad(true);
                this.$api4d.getListeRevuesAnnee(this.auth.token, this.currentAbonnement.key).then(({ data }) => {
                    let dates = data.data;
                    // Abonne
                    if (this.currentAbonnement.isAbonne) {
                        this.dates = dates
                    } else { // history
                        let datesAbo = this.getAllDates();
                        this.dates = dates.filter(item => datesAbo.includes(item));
                    }

                    // ouvrir toutes les dates.
                    this.dates = dates;

                    if (this.dates.length > 0) {
                        this.reloadListe(this.dates[0]);
                    }
                    this.setOnLoad(false);
                }).catch((e) => {
                    this.setOnLoad(false);
                    console.log(e)
                })
            },
            immediate: true
        }
    },
    computed: {
        ...mapState([
            'auth'
        ]),
        ...mapGetters([
            'getAbonnementsStartDates',
            'getAbonnementsEndDates',
            'getSearchFilters',
            'getStartDatesRevue'
        ]),
        isMobile() {
            return this.$vssWidth < 992
        },
    },
    methods: {
        ...mapActions([
            'setOnLoad',
            'setSearchFilters'
        ]),
        back () {
            this.$emit('unselected-revue')
        },
        onChange(e) {
            this.reloadListe(e.target.value)
        },
        reloadListe(year) {
            this.setOnLoad(true);
            this.$api4d.getNumRevuesAnnee(this.auth.token, this.currentAbonnement.key, year).then(({ data }) => {
                this.selectedDate = year
                // let result = data.data;

                // for (let i = 0; i < result.length; i++) {
                //     const element = result[i];
                //     if (element['cover'] == undefined) {
                //         element['cover'] = '@/assets/images/livres.jpg';
                //     }
                // }
                // this.listeNum = result;
                this.listeNum = data.data;
                if (this.listeNum <= 0) {
                    this.emptyNum = true
                } else {
                    this.emptyNum = false
                }
                this.setOnLoad(false);
            }).catch((e) => {
                this.setOnLoad(false);
                console.log(e)
            })
        },
        getAllDates() {
            //console.log(this.getStartDatesRevue(this.currentAbonnement))
            let yearsStart = this.getAbonnementsStartDates
            let yearsEnd = this.getAbonnementsEndDates
            return [...new Set(yearsStart.concat(yearsEnd))]
        },
        OnSearchNumRevue(e) {
            let numRevue = e.target.closest('.numero-item').dataset.numRevue;
            this.filters.nomrevue = this.currentAbonnement.key;
            this.filters.num_revue = numRevue;
            this.filters.annee_parution = this.selectedDate;
            this.setSearchFilters(this.filters);
            this.$router.push({ name: 'rechecherPage' });
        }
    },
    mounted() {
        const userFilters = toRaw(this.getSearchFilters)
        if (Object.keys(userFilters).length !== 0) {
            this.filters = userFilters
        }

        this.description = DESCRIPTIONREVUE_CONSTANTS[this.currentAbonnement.key]
    }
}
</script>

<style lang="scss" scoped>
@import "@/scss/helpers/mixins";
@import "@/scss/helpers/variables";
.container-revue {
    max-width: 900px;
    padding-bottom: 20px;
}

.rechercheRevue {
    &-header {
        padding: 10px;
        margin-top: 20px;

        @include min($lg) {
            display: flex;
            align-items: center;
            gap: 20px;
            margin-top: 3rem;
        }

        .back {
            display: flex;
            align-items: center;
            cursor: pointer;
            margin: 0;
            padding: 0px 15px;

            &::before {
                content: "";
                display: block;
                background: url('@/assets/images/back-arrow.png') no-repeat center;
                width: 9px;
                height: 16px;
            }

            @include min($lg) {
                gap: 10px;
                padding: 9px 20px;
            }

            &-label {
                display: none;

                @include min($lg) {
                    display: inherit;
                }
            }
        }

        .title {
            margin: 0;
            min-width: 150px;
        }

        &--wrapper {
            display: flex;
            justify-content: center;
            gap: 20px;
        }

        .filters {
            width: fit-content;
            margin: 10px auto 0;
            @include min($lg) {
                margin: 0;
                width: inherit;
            }
        }
    }

    &-descriptions {
        padding: 15px 30px;
        @include min($lg) {
            padding: 20px 8rem 20px 8rem;
        }
    }

    &-liste {
        display: flex;
        margin: auto;
        overflow-x: scroll;
        white-space: nowrap;
        justify-content: flex-start;
        
        @include min($lg) {
            overflow-x: hidden;
            justify-content: center;
            flex-wrap: wrap;
            padding: 0 4rem;
        }

        .numero-item {
            flex: 0 0 150px;
            width: 150px;
            white-space: normal;
            margin: 5px 10px;
            text-align: center;
            cursor: pointer;
        
        
            @include min($lg) {
                width: 126px;
                flex: 0 0 126px;
            }
        
        
            img {
                height: auto;
                max-width: 100%;
                border-color: #ffffff;
                border-width: 5px;
                border-style: solid;
                border-radius: 10px;
                box-shadow: 0px 3px 5px rgba(40, 56, 97, 0.2);
                margin: 0 0 10px;
            }

            .numero-text {
                font-size: 12px;
                font-weight: $medium;
                line-height: 12px;
                margin: 0;
            }
        }
    }

    .btn-select {
        background-color: white;
        color: #283861;
        margin: 0;

        &:focus, &:active, &:focus-visible {
            border: transparent;
        }
    }
}
</style>